module.exports = __webpack_public_path__ + "static/media/热点咨询.3a829272.jpg";